export enum FeatureFlags {
	DigitalBalance = 'digitalBalance',
	WhatsAppButtonEnabled = 'whatsappButtonEnabled',
}
